import { sidebarNodeTypes } from '../../../config/config';
import { BaseApi } from '../../common/api/base-api.interface';
import { NodeGroupNodeCreateProps } from '../models/node-group-node-create-props';
import { getApiForNodeType } from './../../common/api/api-map';
import { createNodeGroupNode } from './create-node-group-node';
import { deleteNodeGroupNode } from './delete-node-group-node';
import { setupNodeGroupNode } from './setup-node-group-node';

export const nodeGroupNodeAPI = (): BaseApi<NodeGroupNodeCreateProps> => ({
  name: sidebarNodeTypes.nodeGroupNode,
  setup: setupNodeGroupNode,
  create: createNodeGroupNode,
  getCursor: () => 'crosshair',
  ...getApiForNodeType(sidebarNodeTypes.nodeGroupNode),
  delete: deleteNodeGroupNode,
});
